import LoginContainer from './login.container';

export default LoginContainer;
